import {defineStore} from 'pinia'
import {computed, ref} from 'vue'

export const useSettingsStore = defineStore('SettingsStore', () => {
	const settings = ref(window?.settings || {})

	const getVersion = computed(() => settings.value?.version || 'CZ')
	const isPacketaEnabled = computed(() => settings.value?.isPacketaEnabled ?? false)
	const isPageSK = computed(() => getVersion.value === 'SK')
	const isPageCZ = computed(() => getVersion.value === 'CZ')
	const isPageHU = computed(() => getVersion.value === 'HU')

	const defaultPhonePrefix = computed(() => {
		if (getVersion.value === 'CZ') return '+420'
		if (getVersion.value === 'SK') return '+421'
		if (getVersion.value === 'HU') return '+36'
		return ''
	})

	return {
		defaultPhonePrefix,
		getVersion,
		isPacketaEnabled,
		isPageSK,
		isPageCZ,
		isPageHU,
	}
})
